import { render } from "./HeroiconsSolidTrash.vue?vue&type=template&id=398017f8"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTrash.vue"]])

export default __exports__